import React, { Component } from 'react';
import PropTypes from 'prop-types';

class VisitsStats extends Component {
  render() {
    return (
      <div className="visits__internal">
        <div className="visits__row">
          <div className="visits__box">
            <div className="visits__title">
              Año pasado
            </div>
            <div className="visits__stat">
              {this.props.lastYear}
            </div>
          </div>

          <div className="visits__box">
            <div className="visits__title">
              Este año
            </div>
            <div className="visits__stat">
              {this.props.thisYear}
            </div>
          </div>

          <div className="visits__box">
            <div className="visits__title">
              Últimos 6 meses
            </div>
            <div className="visits__stat">
              {this.props.sixMonths}
            </div>
          </div>
        </div>
        <div className="visits__row">
          <div className="visits__box">
            <div className="visits__title">
              Últimos 30 días
            </div>
            <div className="visits__stat">
              {this.props.thirtyDays}
            </div>
          </div>

          <div className="visits__box">
            <div className="visits__title">
              Últimos 7 días
            </div>
            <div className="visits__stat">
              {this.props.sevenDays}
            </div>
          </div>

          <div className="visits__box">
            <div className="visits__title">
              Hoy
            </div>
            <div className="visits__stat">
              {this.props.today}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VisitsStats.propTypes = {
  lastYear: PropTypes.number,
  thisYear: PropTypes.number,
  sixMonths: PropTypes.number,
  thirtyDays: PropTypes.number,
  sevenDays: PropTypes.number,
  today: PropTypes.number,
};

VisitsStats.defaultProps = {
  lastYear: 0,
  thisYear: 0,
  sixMonths: 0,
  thirtyDays: 0,
  sevenDays: 0,
  today: 0,
};

export default VisitsStats;



// WEBPACK FOOTER //
// ./src/components/VisitsStats/index.js